import React, { useState } from "react";
import { MdImage } from "react-icons/md";

const QuestionImagePreview = ({ imageUrl }) => {
  const [imageError, setImageError] = useState(false);

  if (!imageUrl || imageError) {
    return (
      <div className="flex h-44 w-64 flex-col items-center justify-center rounded-lg border border-gray-300 bg-gray-50">
        <MdImage className="text-5xl text-gray-400" />

        <p className="mt-2 text-sm text-gray-500">
          No Image Uploaded
        </p>
      </div>
    );
  }

  return (
    <div
      className="flex h-44 w-64 items-center justify-center overflow-hidden rounded-lg border border-gray-300 bg-gray-50"
    >
      <img
        src={imageUrl}
        alt="Question"
        onError={() => setImageError(true)}
        className="max-h-full max-w-full object-contain"
      />
    </div>
  );
};

export default QuestionImagePreview;